import {
  createTheme,
  Divider,
  ThemeProvider as MuiThemeProvider,
  Stack,
  useTheme,
} from '@mui/material';
import {
  InsertHorizontalRuleButton,
  RedoButton,
  ToggleBoldButton,
  ToggleBulletListButton,
  ToggleCodeBlockButton,
  ToggleCodeButton,
  ToggleItalicButton,
  ToggleOrderedListButton,
  ToggleStrikeButton,
  ToggleTaskListButton,
  ToggleUnderlineButton,
  UndoButton,
} from '@remirror/react-ui';
import { CreateTableButton } from './create-table-button';
import { HeadingMenu } from './heading-menu';

const MenuDivider = () => (
  <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 1 }} />
);

export const Toolbar = () => {
  const appTheme = useTheme();

  const menuTheme = createTheme({
    ...appTheme,
    shape: {
      ...appTheme.shape,
    },
    typography: {
      ...appTheme.typography,
    },
    components: {
      ...appTheme.components,
      MuiToggleButton: {
        styleOverrides: {
          root: () => ({
            '&&': {
              padding: 8,
              borderRadius: '50%',
              borderColor: 'transparent',

              '&.Mui-selected': {
                backgroundColor: 'inherit',
                borderColor: 'transparent',
                color: appTheme.palette.secondary.main,
                '&:hover': {
                  backgroundColor: appTheme.palette.neutral[300],
                  color: appTheme.palette.secondary.main,
                },
              },

              '& > svg': {
                transform: 'scale(1.2)',
              },
            },
          }),
        },
      },
    },
  });

  return (
    <MuiThemeProvider theme={menuTheme}>
      <Stack
        direction="row"
        gap={0.5}
        sx={{ alignItems: 'center', overflowX: 'auto' }}
      >
        <HeadingMenu />
        <ToggleBulletListButton label="Lista" />
        <ToggleOrderedListButton label="Lista ordenada" />
        <ToggleTaskListButton label="Lista de tarefas" />
        <MenuDivider />
        <ToggleCodeButton label="Código" />
        <ToggleBoldButton label="Negrito" />
        <ToggleItalicButton label="Itálico" />
        <ToggleStrikeButton label="Tachado" />
        <ToggleUnderlineButton label="Sublinhado" />
        <MenuDivider />
        <InsertHorizontalRuleButton label="Inserir divisor" />
        <CreateTableButton label="Inserir tabela" />
        <ToggleCodeBlockButton />
        <MenuDivider />
        <UndoButton label="Desfazer" />
        <RedoButton label="Refazer" />
      </Stack>
    </MuiThemeProvider>
  );
};
